import { IPassOnFormValuesAction } from "../../types/wizard-types";
import { ACTION_PASS_ON_FORM_VALUES } from "../../constants";

export const passOnFormValues = (fn): IPassOnFormValuesAction => ({
  type: ACTION_PASS_ON_FORM_VALUES,
  payload: fn,
});
